module.exports = __webpack_public_path__ + "img/ko_hy.7462aa28.jpg";